module.exports = __webpack_public_path__ + "media/images/icons/drag-handle-f90c464cd9eb53ffa838f0682f616c6b.svg";